import {Radio, Select} from "antd";
import {AppActions, useAppContext} from "../context/AppContext";


export default function CrossSectionFilter({csList = [], type}) {
    const {filter, dispatchProject, getCSList} = useAppContext()

    const renderCSList = (cs_list) => {
        return (cs_list || [])?.map(x => (
            <Select.Option key={x.name} value={x.name}>
                {x.name}
            </Select.Option>
        ))
    }

    const dispatchFilter = (partialFilter) => {
        dispatchProject({
            type: AppActions.SET_FILTER,
            data: {
                filter: {
                    ...(filter || {}),
                    ...partialFilter
                }
            }
        })
    }

    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <Select
                placeholder={'DS'}
                style={{width: 150}}
                size={'small'}
                suffixIcon={(<b>DS</b>)}
                value={filter?.ds}
                onChange={(val) => dispatchFilter({ds: val})}
            >
                {
                    renderCSList([...getCSList()].filter((x, idx) => idx > 0)).reverse()
                }
            </Select>
            <Select
                placeholder={'US'}
                style={{width: 150}}
                size={'small'}
                suffixIcon={(<b>US</b>)}
                value={filter?.us}
                onChange={(val) => dispatchFilter({us: val})}
            >
                {
                    renderCSList([...getCSList()])
                }
            </Select>
            <Radio.Group
                options={[
                    {label: 'Color', value: 'highlight'},
                    {label: 'Filter', value: 'filter'},
                    {label: 'Clear', value: 'clear'},
                ]}
                onChange={(e) => {
                    if(e.target.value === 'clear') {
                        dispatchFilter({us: '', ds: '', type: 'clear'})
                    } else {
                        dispatchFilter({type: e.target.value})
                    }
                }}
                value={filter?.type}
                optionType="button"
                buttonStyle="solid"
                size={'small'}
            />
        </div>
    )
}